import { ScrollButtonStatus, SideScrollType } from '../../components/forecasts/common/types';

export const SET_SCROLL_BUTTON_STATUS = 'SET_SCROLL_BUTTON_STATUS';
export const SET_SIDE_SCROLL = 'SET_SIDE_SCROLL';
export const RESET_SCROLL_DATA = 'RESET_SCROLL_DATA';

export type SetSideScrollType = {
    type: typeof SET_SIDE_SCROLL;
    payload: SideScrollType;
}

export type SetScrollButtonStatusType = {
    type: typeof SET_SCROLL_BUTTON_STATUS;
    payload: ScrollButtonStatus
}

export type ResetScrollDataType = {
    type: typeof RESET_SCROLL_DATA;
    payload?: any
}

export function setForecastScrollButtonStatus(buttonStatus: ScrollButtonStatus): SetScrollButtonStatusType {
    return {
        type: SET_SCROLL_BUTTON_STATUS,
        payload: buttonStatus
    };
}

export function setForecastSideScroll(sideScrollData: SideScrollType): SetSideScrollType {
    return {
        type: SET_SIDE_SCROLL,
        payload: sideScrollData
    };
}

export function resetForecastScrollData(): ResetScrollDataType {
    return {
        type: RESET_SCROLL_DATA
    };
}